export default __webpack_public_path__ + "static/media/building.24df3f23.jpg";